<template>
  <div class='uploadImg'>
    <!-- 遮罩层 -->
    <!--<div class='popuptier' v-show="panel"></div>-->
    <!--上传-->
    <el-upload :ref="upload" class="avatar-uploader" :action="imgurl()" :auto-upload="false" :on-change="change" :on-success="handleAvatarSuccess" :http-request='myUpload' :show-file-list="false" :data="formData">
      <img v-if="imageUrl" :src="imageUrl" class="avatar">
      <i v-else class="el-icon-plus avatar-uploader-icon"></i>
    </el-upload>
    <!--裁剪层-->
    <div class="container" v-show="panel">
      <!--<div class='popuptier' v-show="loading">
        <div>
          <i class="el-icon-loading" style='font-size: 40px;color:#409eff;'></i>
          <span style='font-size: 16px;display:block;margin-top: 10px;'>拼命上传中</span>
        </div>
      </div>-->
      <div class="el-dialog__header">
        <span class="container_title">图片裁剪</span>
        <button type="button" class="container_close" @click="cancel">
          <i class="el-dialog__close el-icon el-icon-close"></i>
        </button>
      </div>
      <div v-show="panel" style="margin: 20px 0">
          <img :id="imgBoxId" :src="url" style="width:100%;height:auto;" alt="Picture">
      </div>
      <div class="rotateimg" style="margin: 20px 0;">
        <span class="wise anticlockwise" @click="rotateimgleft()"></span>
        <span class="wise clockwise" @click="rotateimgright()" style='margin-right: 10%;'></span>
        <el-button class="btn-primary" size='large' @click="commit">确定</el-button>
        <el-button class="btn-default" @click="cancel" style='margin-right: calc(100px + 10%);'>取消</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/com/ajax.js'
import config from '@/com/config.js'
import Cropper from 'cropperjs'
require('res/css/uploadImg.css')
export default {
  data () {
    return {
      image: '',
      picValue: '',
      cropper: '',
      croppable: false,
      panel: false,
      // loading: false,
      url: '',
      formData: {'uploadType': 1},
      imgCropperData: {
        accept: 'image/jpeg, image/png, image/jpg'
      },
      dialogTableVisible: false,
      token: ''
    }
  },
  props: {
    imgBoxId: {
      type: String,
      default: 'image'
    },
    upload: {
      type: String,
      default: 'upload'
    },
    imageUrl: {
      type: String,
      default: ''
    }
  },
  mounted () {
    // 初始化这个裁剪框
    var self = this
    var image = document.getElementById(this.imgBoxId)
    this.cropper = new Cropper(image, {
      aspectRatio: 4 / 3,
      viewMode: 1, // 定义cropper的视图模式,
      background: false,
      dragCrop: false, // 是否允许移除当前的剪裁框，并通过拖动来新建一个剪裁框区域。
      cropBoxMovable: false, // 是否通过拖拽来移动剪裁框
      modal: false, // 是否有遮罩层
      // movable: true, // 是否可以移动图片
      toggleDragModeOnDblclick: false,
      scalable: true, // 是否允许缩放图像
      zoomable: true, // 是否允许放大图像
      rotatable: true, // 旋转
      ready: function () {
        self.croppable = true
        self.cropper.setDragMode('move')// 移动图片
      }
    })
  },
  methods: {
    imgurl () { // 上传插件地址
      this.token = localStorage.getItem('token')
      return config.khsHost + 'picture/teacher/uploadFile.do?HaiziguoToken=' + this.token
    },
    rotateimgright () {
      this.cropper.rotate('90')
    },
    rotateimgleft () {
      this.cropper.rotate('-90')
    },
    change (file) {
      let isJPG, isLt1M
      if (this.imgCropperData.accept.indexOf(file.raw.type) === -1) {
        this.$message.error('上传图片只能是 JPG、JPEG 或 PNG 格式!')
        return false
      } else {
        isJPG = true
      }
      if ((file.size > 5242880)) {
        this.$message.error('图片过大,请选择 5MB 以内的图片!')
        return false
      } else {
        isLt1M = true
      }
      this.picValue = file.raw
      this.url = this.getObjectURL(this.picValue)
      // 每次替换图片要重新得到新的url
      if (this.cropper) {
        this.cropper.replace(this.url)
      }
      this.panel = true
      return isJPG && isLt1M
    },
    myUpload (content) {
      var self = this
      var formData = new FormData()
     // self.$root.PreviewHub.$emit('upload', [true])  // 显示进度条
      var img = this.dataURLtoFile(self.imageUrl, content.file.name)
      formData.append('file', img, content.file.name)
      formData.append('uploadType', content.data.uploadType)
      api.post(content.action, formData).then(function (response) {
        if (response.success === true) {
          self.$message.success('上传成功')
          self.imageUrl = response.body
          self.$emit('url', self.imageUrl)
        } else {
          self.$message.error('上传失败')
        }
        // self.loading = false
       // self.$root.PreviewHub.$emit('upload', [false]) // 关闭进度条
      })
    },
    // 取消上传
    cancel () {
      this.panel = false
    },
    // 创建url路径
    getObjectURL (file) {
      var url = null
      if (window.createObjectURL !== undefined) {
        // basic
        url = window.createObjectURL(file)
      } else if (window.URL !== undefined) {
        // mozilla(firefox)
        url = window.URL.createObjectURL(file)
      } else if (window.webkitURL !== undefined) {
        // webkit or chrome
        url = window.webkitURL.createObjectURL(file)
      }
      return url
    },
    // 确定提交
    commit () {
      // this.loading = true
      this.panel = false
      var croppedCanvas
      var canvas
      if (!this.croppable) {
        return
      }
      // Crop
      croppedCanvas = this.cropper.getCroppedCanvas()
      // Round
      canvas = this.getCanvas(croppedCanvas)
      this.imageUrl = canvas.toDataURL()
      // 上传图片
      this.$refs[this.upload].submit()
    },
    dataURLtoFile (dataurl, filename) {
      let arr = dataurl.split(',')
      let mime = arr[0].match(/:(.*?);/)[1]
      let bstr = atob(arr[1])
      let n = bstr.length
      let u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new File([u8arr], filename, {type: mime})
    },
    // canvas画图
    getCanvas (sourceCanvas) {
      var canvas = document.createElement('canvas')
      var context = canvas.getContext('2d')
      var width = sourceCanvas.width
      var height = sourceCanvas.height
      canvas.width = width
      canvas.height = height
      context.imageSmoothingEnabled = true
      context.drawImage(sourceCanvas, 0, 0, width, height)
      context.globalCompositeOperation = 'destination-in'
      context.beginPath()
      context.rect(0, 0, width, height)
      context.fill()
      return canvas
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/utils/uploadImg.vue?888dcd4c